export type Framework = "react" | "svelte" | "astro" | "vue" | "vanilla"
export type MetaFramework = "next" | "remix" | "sveltekit" | "nuxt" | "none"
export type PackageManager = "npm" | "pnpm" | "yarn" | "bun"
export type CodeQualityTool = "biome" | "eslint-prettier"

export interface ProjectConfig {
  projectName: string
  projectPath: string
  framework: Framework
  metaFramework: MetaFramework
  typescript: boolean
  tailwind: boolean
  packageManager: PackageManager
  codeQuality: CodeQualityTool
  gitHooks: boolean
  dryRun: boolean
  debug: boolean
}

export interface FrameworkConfig {
  name: Framework
  displayName: string
  metaFrameworks: Array<MetaFramework>
  defaultMeta: MetaFramework
  starter: StarterConfig
}

export interface StarterConfig {
  command: string
  args: (config: ProjectConfig) => Array<string>
  postInstall?: (config: ProjectConfig) => Promise<void>
}

export interface FeatureInstaller {
  name: string
  install: (config: ProjectConfig) => Promise<void>
  validate?: (config: ProjectConfig) => boolean
}

export interface PackageManagerCommands {
  install: string
  add: string
  addDev: string
  run: string
  exec: string
  init: string
}

export interface CLIOptions {
  framework?: Framework
  meta?: MetaFramework
  typescript?: boolean
  tailwind?: boolean
  pm?: PackageManager
  quality?: CodeQualityTool
  gitHooks?: boolean
  preset?: string
  dryRun?: boolean
  debug?: boolean
}

export interface Preset {
  name: string
  description: string
  config: Partial<ProjectConfig>
}

export interface TemplateData {
  [key: string]: string
}

export interface Logger {
  info: (message: string) => void
  success: (message: string) => void
  warning: (message: string) => void
  error: (message: string) => void
  debug: (message: string) => void
}

export interface FileOperation {
  type: "create" | "update" | "delete"
  path: string
  content?: string
  encoding?: BufferEncoding
}

export class CLIError extends Error {
  constructor(
    message: string,
    public code: string,
    public details?: any,
  ) {
    super(message)
    this.name = "CLIError"
  }
}
